varying vec3 vposition;
varying vec2 vUv;
varying vec3 vNormal;
void main()
{

    // Normal

    // Position
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
        // Model normal
    vec4 modelNormal = modelMatrix * vec4(normal, 0.0);
 vNormal = modelNormal.xyz;
    vposition = modelPosition.xyz;
    vUv = uv;
    // Final position
    gl_Position = projectionMatrix * viewMatrix * modelPosition;
}
